import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_network, use_slice_workspace } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';

export function WATCHER__disable_generation_ui() {
  const dispatch = use_dispatch();

  const { responses_ids__wait_to } = use_slice_network(['responses_ids__wait_to']);
  const { generation_current } = use_slice_generation(['generation_current']);
  const { is_all_data_loaded } = use_slice_workspace(['is_all_data_loaded']);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (!is_all_data_loaded) return;
    if (generation_current.is_stub()) return;

    let need_disable_by_status = generation_current.is_in_progress || generation_current.is_locked() || responses_ids__wait_to.size > 0;

    let value = need_disable_by_status;

    dispatch(LOCAL__ui_set_boolean({ key: 'g_general__ui_disabled', value }));
  }, [is_all_data_loaded, generation_current.status, responses_ids__wait_to]);

  /*
   * METHODS
   */

  return <></>;
}
